window.blogProductTrackingLoaded = true;

console.log('BLOG TRACKING LOADED');

document.addEventListener('click', function (e) {

  const btn = e.target.closest('[data-blog-product-event]');

  if (!btn) return;

  const card = btn.closest('[data-blog-product-card]');

  if (!card) return;

  const eventName = btn.dataset.blogProductEvent;

  window.dataLayer = window.dataLayer || [];

window.dataLayer.push({
  event: eventName,
  article_title: document.title,
  product_id: card.dataset.productId,
  product_handle: card.dataset.productHandle,
  product_title: card.dataset.productTitle,
  product_position: card.dataset.productPosition
});

  console.log('BLOG EVENT SENT', {
    event: eventName,
    article_title: document.title,
    product_id: card.dataset.productId,
    product_handle: card.dataset.productHandle,
    product_title: card.dataset.productTitle
  });

});